module.exports = __webpack_public_path__ + "img/favorite.01ff1db0.svg";